import serviceGroupHasService from '../serviceGroupHasService';

const quoteHasAddon = ({ service_groups: serviceGroups, products }, productId) => {
  if (serviceGroups.some((serviceGroup) => serviceGroupHasService(serviceGroup, productId))) {
    return true;
  }
  if (products.some((product) => product.product_id === productId)) {
    return true;
  }
  return false;
};

export default quoteHasAddon;
